import React from 'react';
import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LanguageContext from 'context/LanguageContext';

// Components
import Navbar from 'components/Navbar/Navbar';
import Footer from 'components/Footer/Footer';

// Pages IT_it
import Home from 'Pages/IT_it/Home/Home';
import Azienda from 'Pages/IT_it/Azienda/Azienda';
import Personale from 'Pages/IT_it/Personale/Personale';
import Prodotti from 'Pages/IT_it/Prodotti/Prodotti';
import Progetti from 'Pages/IT_it/Progetti/Progetti';
import Carriera from 'Pages/IT_it/Carriera/Carriera';
import Servizi from 'Pages/IT_it/Servizi/Servizi';
import Contatti from 'Pages/IT_it/Contattaci/Contatti';
import PageNotFound from 'Pages/IT_it/PageNotFound/PageNotFound';
import Privacy from 'Pages/IT_it/Privacy/Privacy';

// Pages EN_en
import HomeEn from 'Pages/EN_en/Home/Home';
import AziendaEn from 'Pages/EN_en/Azienda/Azienda';
import ProdottiEn from 'Pages/EN_en/Prodotti/Prodotti';
import ApplicazioniEn from 'Pages/EN_en/Applicazioni/Applicazioni';
import ServiziEn from 'Pages/EN_en/Servizi/Servizi';
import ContattiEn from 'Pages/EN_en/Contattaci/Contatti';

function App() {
  const [language, setLanguage] = useState('it');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <BrowserRouter>
        <Navbar />
        {language === 'it' && (
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/company" element={<Azienda />}></Route>
            <Route path="/team" element={<Personale />}></Route>
            <Route path="/prodotti" element={<Prodotti />}></Route>
            <Route path="/progetti" element={<Progetti />}></Route>
            <Route path="/servizi" element={<Servizi />}></Route>
            <Route path="/carriera" element={<Carriera />}></Route>
            <Route path="/contatti" element={<Contatti />}></Route>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        )}
        {language === 'en' && (
          <Routes>
            <Route path="/" element={<HomeEn />}></Route>
            <Route path="/company" element={<AziendaEn />}></Route>
            <Route path="/team" element={<Personale />}></Route>
            <Route path="/products" element={<ProdottiEn />}></Route>
            <Route path="/projects" element={<Progetti />}></Route>
            <Route path="/services" element={<ServiziEn />}></Route>
            <Route path="/careers" element={<Carriera />}></Route>
            <Route path="/contact-us" element={<ContattiEn />}></Route>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        )}
        <Footer />
      </BrowserRouter>
    </LanguageContext.Provider>
  );
}

export default App;
